// This fires the print dialog, applying only the @media print rules in the scss:
export function exportChatPdf() {
    window.print();
  }
